import React, { FunctionComponent } from 'react';
import { Typography, Grid, UIThemeProvider } from '@rbx/ui';
import { resolveStaticSrc } from '@modules/ui/markdown/utils/staticLinkUtils';
import useSideBarContent from '@modules/ui/shared/hooks/useSideBarContent';
import useAppBannerStyles from './AppBanner.styles';
import { useAppConfig } from './AppConfigProvider';

export type AppBannerVariant = 'primary' | 'secondary';
export interface AppBannerProps {
  title: string;
  backgroundUrl: string;
  subtitle?: string | null;
  variant?: AppBannerVariant;
  className?: string;
}

const AppBanner: FunctionComponent<React.PropsWithChildren<AppBannerProps>> = ({
  children,
  title,
  subtitle,
  backgroundUrl,
  variant = 'secondary',
  className,
}) => {
  const {
    classes: { container, textContainer },
    cx,
  } = useAppBannerStyles({
    backgroundUrl: resolveStaticSrc(backgroundUrl) ?? '',
    variant,
  });
  const { hasLeftNav } = useSideBarContent();
  const { enableNewLayout } = useAppConfig();

  return (
    // the content stays in dark theme, since the background image is dark color
    <UIThemeProvider theme='dark' cssBaselineMode='disabled'>
      <Grid
        className={cx(container, className)}
        container
        alignItems='center'
        justifyContent={hasLeftNav && !enableNewLayout ? 'flex-start' : 'center'}>
        <Grid className={textContainer} container direction='column'>
          <Typography variant='h1' component='h1' color='primary'>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant='captionBody' color='primary' style={{ fontSize: '24px' }}>
              {subtitle}
            </Typography>
          )}
          {children}
        </Grid>
      </Grid>
    </UIThemeProvider>
  );
};

export default AppBanner;
